import React, { useState, useMemo } from 'react';
import DataTableV3 from 'src/components/DataTableV3';
import { Button } from '@innovationnorway/cl-react';
import { sponsorColumns } from '../constants/sponsor-columns';
import { Sponsor } from 'src/api/v2';
import { UseFormSetValue } from 'react-hook-form';
import { RowSelectionState } from '@tanstack/react-table';
import { useSponsorList, SponsorListType } from '../hooks/use-sponsor-list';
import { ContactInfoData } from '../hooks/subforms/use-contact-info-form';

type Props = {
  selectedSponsors: SponsorListType[];
  setSelectedSponsors: React.Dispatch<React.SetStateAction<SponsorListType[]>>;
  isLoading?: boolean;
  setValue: UseFormSetValue<ContactInfoData>;
  close: () => void;
};

const SelectSponsorTable: React.FC<Props> = ({ selectedSponsors, setSelectedSponsors, setValue, close }) => {
  const { AllSponsorList } = useSponsorList();
  const [selected, setSelected] = useState<SponsorListType[]>([]);

  const preselectedRows = useMemo(() => {
    return Object.values(Sponsor).reduce((acc, sponsor, index) => {
      if (selectedSponsors.find((s) => s.name == sponsor)) {
        acc[index] = true;
      }
      return acc;
    }, {} as RowSelectionState);
  }, [selectedSponsors]);

  return (
    <div>
      <DataTableV3
        disableColumnEditor
        disableGlobalFilter
        disableExport
        hideFilterText
        setSelectedRows={setSelected}
        data={AllSponsorList}
        columns={sponsorColumns}
        id={'select-sponsors'}
        preselectedRows={preselectedRows}
      />
      <div className="display--flex gap--2">
        <Button
          onClick={() => {
            setSelectedSponsors(selected);
            if (selected.length > 0) {
              setValue(
                'sponsors',
                selected.map((x) => x.name),
              );
            } else {
              setValue('sponsors', []);
            }
            close();
          }}
        >
          Legg til
        </Button>
        <Button variant="secondary" onClick={() => close()}>
          Avbryt
        </Button>
      </div>
    </div>
  );
};

export default SelectSponsorTable;
